export default __webpack_public_path__ + "static/media/logo.9dbc31c1.svg";